import React from 'react';
import qp from 'query-parse';

import { showCreateProjectModal } from '../actions/projects';
import { openFlyout } from '../actions/flyout';

import { isMac } from 'services/env-service';
import { openWindow } from '../utils';
import { buildAppUrl } from '../utils/url';
import { browserHistory } from './history';
import { createAlert } from './alert-service';
import { createDoc } from '../actions/docs';
import { showModal } from '../actions/modal';

let completed = false;
let hasError = false;

export const emit = (name, ...args) => {
    if (window.ipcRenderer) {
        window.ipcRenderer.send(name, ...args);
    }
}

export const onceElectronEvent = (name, callback) => {
    if (window.ipcRenderer) {
        window.ipcRenderer.once(name, callback);
    }
}

export const openElectronHelperBrowser = ({ params = {}, windowProps, onMessage }) => {
    const key = new Date().getTime().toString();
    const winParams = {
        ...params,
        key
    };

    const messageHandler = event => {
        if (event.data && typeof event.data === 'object') {
            if (!event.data.key) {
                if (event.data.action === 'LOAD') {
                    sendInit();
                }
            } else if (event.data.key === key) {
                if (event.data.action === 'REJECT') {
                    destroy();
                } else {
                    onMessage(event.data)
                }
            }
        }
    }

    const sendInit = () => {
        win.postMessage({
            action: 'INIT',
            payload: winParams
        });
    }

    const win = openWindow(buildAppUrl(`/electron-helper-browser?${qp.toString(winParams)}`), windowProps, 'electron-helper-browser');

    const destroy = () => {
        window.removeEventListener('message', messageHandler, false);
        win.close();
    }

    window.addEventListener('message', messageHandler, false);

    return destroy;
}

const getProjectIdFromUrl = () => browserHistory.getCurrentLocation().pathname.match(/^(.*?)\//)[1];

const updateAlert = createAlert('success', 'App update available.', {
    hidden: true,
    hard: true
});

const handleRestartClick = event => {
    event.preventDefault();
    emit('restartAndInstall');
}

const showProgress = percent => {
    if (hasError) {
        return;
    }

    updateAlert.show();

    if (completed) {
        return;
    }

    if (Math.round(percent) === 100) {
        showCompleted();
    } else {
        updateAlert.setType('success').setContent(`<i class="icon material-icons icon-animate-rotate">autorenew</i> Downloading update ${Math.round(percent)}%`);
    }
}

const showCompleted = () => {
    completed = true;

    updateAlert.show();
    updateAlert.setType('success').setContent(<div>Update downloaded. Please <u className="clickable" onClick={handleRestartClick}>restart</u> Nifty to install it.</div>);
}

const showError = () => {
    hasError = true;

    updateAlert.show();
    updateAlert.setType('default').setContent(<div>Auto update failed. You can download the new version manually from <a href={'https://niftypm.com/apps/Nifty.' + (isMac() ? 'dmg' : 'exe')} target="_blank">here</a>.</div>);
}

if (window.ipcRenderer) {
    window.ipcRenderer.on('innerRedirect', (sender, url) => {
        browserHistory.push(url);
    });

    window.ipcRenderer.on('update-available', () => {
        updateAlert.show();
    });

    window.ipcRenderer.on('update-progress', (sender, params) => {
        showProgress(params.percent);
    });

    window.ipcRenderer.on('update-downloaded', () => {
        showCompleted();
    });

    window.ipcRenderer.on('update-error', () => {
        showError();
    });

    window.ipcRenderer.on('uiAction', (sender, action, ...args) => {
        switch (action) {
            case 'showOverview':
                openFlyout('overview')
                break;

            case 'invitePeople':
                browserHistory.push(`/settings/team/current/people`);
                break;

            case 'createProject':
                showCreateProjectModal()
                break;

            case 'createTask':
                showModal('CREATE_TASK_SIMPLE', {
                    name: args[0],
                    projectId: getProjectIdFromUrl()
                });
                break;

            // case 'createDoc':
            //     createDoc(getProjectIdFromUrl())
            //         .then(docId => browserHistory.push(`${getProjectIdFromUrl()}/documents/${docId}`))
            //     break;

            case 'uploadFile':
                browserHistory.push(`${getProjectIdFromUrl()}/files/upload`);
                break;

            default:
                return;
        }
    });
}
